<template xmlns:table="http://www.w3.org/1999/html">
  <div class="body">
    <el-button style="margin-bottom: 5px;margin-top: 5px;" type="primary" :loading="addCsSpecialLoading" @click="addCsSpecialApplication">特殊申请</el-button>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane name="first" label="基础信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{replacementBillVo.billNo}}</td>
            <td class="tableLabel">客户单号：</td>
            <td>
              <el-input v-model="replacementBillVo.customerBillNo" placeholder="请输入" clearable/>
            </td>
            <td class="tableLabel">登记日期：</td>
            <td>{{replacementBillVo.createTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">下单人：</td>
            <td>{{replacementBillVo.creatorName}}</td>
            <td class="tableLabel">客户名称：</td>
            <td>
              <el-input v-model="replacementBillVo.customerName" placeholder="请输入" clearable>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    style="margin-left: 2%;"
                    @click="$refs.selectCustomer.open()">
                  选择
                </el-button>
              </el-input>
              <customer-select ref="selectCustomer" @select="selectCustomer"/>
            </td>
            <td class="tableLabel">出厂编号：</td>
            <td>
              <el-input v-model="replacementBillVo.salesOrderNo" placeholder="请输入" clearable/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">现场人员：</td>
            <td>
              <el-input v-model="replacementBillVo.contact" placeholder="请输入" clearable/>
            </td>
            <td class="tableLabel">联系方式-现场：</td>
            <td>
              <el-input v-model="replacementBillVo.mobile" placeholder="请输入" clearable/>
            </td>
            <td class="tableLabel">项目名称：</td>
            <td>
              <el-input v-model="replacementBillVo.siteName" placeholder="请输入" clearable/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">收货人：</td>
            <td>
              <el-input v-model="replacementBillVo.consignee" placeholder="请输入" clearable/>
            </td>
            <td class="tableLabel">联系方式-收货：</td>
            <td>
              <el-input v-model="replacementBillVo.consigneeMobile" placeholder="请输入" clearable/>
            </td>
            <td class="tableLabel">快递方式：</td>
            <td>
              <el-select v-model="replacementBillVo.deliveryType" filterable placeholder="请选择">
                <el-option
                    v-for="(item,index) in constants.deliveryType.$options"
                    :key="index"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">销售员：</td>
            <td>{{replacementBillVo.salesMan}}</td>
            <td class="tableLabel">运费是否到付：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.deliveryPaymentType">
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">项目号：</td>
            <td>
              <el-input
                  v-model="replacementBillVo.faultSerialNO"
                  readonly
                  type="textarea"
                  autosize
                  placeholder="请输入"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否过质保：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.underWarranty" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">现场环境：</td>
            <td>
              <el-select v-model="replacementBillVo.environment" disabled placeholder="请选择">
                <el-option
                    v-for="item in constants.environment.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </td>
            <td class="tableLabel">故障发生阶段：</td>
            <td>
              <el-select v-model="replacementBillVo.stage" disabled placeholder="请选择">
                <el-option
                    v-for="item in constant.toSelect(constant.stage)"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否已技术支持：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.isTechnicalSupport" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">是否已质量核实：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.isSurvey" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">是否海外：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.isOverseas" disabled>
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">收货地址：</td>
            <td colspan="5">
              <el-input v-model="replacementBillVo.deliveryAddress" type="textarea" placeholder="请输入" clearable/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">备注：</td>
            <td colspan="5">
              <el-input v-model="replacementBillVo.note" type="textarea" placeholder="请输入" clearable/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">特批申请结果：</td>
            <td>
              <el-radio-group v-model="replacementBillVo.specialApplicationResult">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">审批中</el-radio>
                <el-radio :label="3">未通过</el-radio>
              </el-radio-group>
            </td>
            <td class="tableLabel">前序订单发运时间：</td>
            <td>
              {{replacementBillVo.completeEndDate}}
            </td>
            <td class="tableLabel">总金额：</td>
            <td>
              {{replacementBillVo.allAmount}}
            </td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="调查结果">
        <table
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">调查结果：</td>
            <td>
              {{replacementBillVo.findings}}
            </td>
            <td class="tableLabel">责任划分：</td>
            <td>
              <div>
                <el-radio-group v-model="replacementBillVo.dutyType" disabled>
                  <el-radio :label="1">新时达责任</el-radio>
                  <el-radio :label="2">供应商责任</el-radio>
                  <el-radio :label="3">客户责任</el-radio>
                </el-radio-group>
              </div>
            </td>
            <td class="tableLabel">处理人：</td>
            <td>
              {{replacementBillVo.cqeApproveName}}
            </td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div
          style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
        物料信息
      </div>
      <el-button type="primary" style="margin-bottom: 10px" @click="getDetails1">
        新建
      </el-button>
      <el-button type="success" style="margin: 10px 10px" :loading="saveLoading" @click="toSave()">保存</el-button>
      <div class="vm-separate" style="width: 60%;margin-bottom: 10px">
        <el-input v-model="replacementBillVo.salesOrderNo" size="mini">
          <span slot="prepend">出厂编号</span>
        </el-input>
        <el-input v-model="replacementBillVo.approveNote" style="margin-left: 2%" size="mini">
          <span slot="prepend">备注</span>
        </el-input>
      </div>

      <el-table
          :data="replacementBillVo.details"
          border>
        <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo" placeholder="请输入">
              <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="materialDesc" width="140" align="center" label="物料名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialDesc" placeholder="请输入" autosize type="textarea"/>
          </template>
        </el-table-column>
        <el-table-column prop="materialType" width="140" align="center" label="产品分类">
          <template slot-scope="scope">
            <el-select v-model="scope.row.materialType" clearable size="mini" placeholder="请选择">
              <el-option
                  v-for="(item,index) in constants.materialType.$options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="originalSoftware" width="110" align="center" label="原程序号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.originalSoftware" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="presentSoftware" width="125" align="center" label="现程序号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.presentSoftware" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="mainPartsSerialNo" width="130" align="center" label="变频器/板卡序列号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.mainPartsSerialNo" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="faultCode" width="90" align="center" label="故障码">
          <template slot-scope="scope">
            <el-input v-model="scope.row.faultCode" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="faultType" width="120" align="center" label="故障分类">
          <template slot-scope="scope">
            <el-select v-model="scope.row.faultType" clearable size="mini" placeholder="请选择">
              <el-option
                  v-for="item in constants.faultType.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" width="75" align="center" label="数量">
          <template slot-scope="scope">
            <!--            <el-input-number v-model="scope.row.quantity" :precision="2" :step="0.1"/>-->
            <el-input v-model="scope.row.quantity" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="unit" width="70" align="center" label="单位">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unit" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="isNewRequest" width="80" align="center" label="是否新件">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isNewRequest" clearable size="mini" placeholder="请选择">
              <el-option label="否" :value="0"/>
              <el-option label="是" :value="1"/>
              <el-option label="可新可旧" :value="2"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="problemType" width="90" align="center" label="问题分类">
          <template slot-scope="scope">
            <el-select
                v-if="replacementBillVo.billNo.includes('ZJ')"
                v-model="scope.row.problemType"
                clearable
                size="mini"
                placeholder="请选择">
              <el-option
                  v-for="(item,index) in constants.problemType.$options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
            <el-select
                v-else
                v-model="scope.row.problemType"
                clearable
                size="mini"
                placeholder="请选择">
              <el-option
                  v-for="(item,index) in constants.problemType2.$options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="responsibleDept" width="100" align="center" label="责任部门">
          <template slot-scope="scope">
            <el-select v-model="scope.row.responsibleDept" clearable size="mini" placeholder="请选择">
              <el-option
                  v-for="item in constants.responsibleDepartment.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryType" width="120" align="center" label="发运类型">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryType" placeholder="请选择">
              <el-button slot="append" icon="el-icon-search" @click="$refs.deliverySelect.open(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryPerson" width="120" align="center" label="发运人"/>
        <el-table-column prop="deliveryBillNo" width="120" align="center" label="发运单号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryBillNo" type="textarea" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryDate" label="发运日期" align="center" width="160"/>
        <el-table-column prop="serialNo" width="120" align="center" label="发出-序列号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.serialNo" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryWay" width="120" align="center" label="发运方式">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryWay" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="isMustBack" width="100" align="center" label="是否必退">
          <template slot-scope="scope">
            <el-select v-model="scope.row.isMustBack" clearable size="mini" placeholder="请选择">
              <el-option label="是" :value="true"/>
              <el-option label="否" :value="false"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryNote" width="120" align="center" label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.deliveryNote" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="100">
          <template slot-scope="scope">
            <el-button type="danger" @click="materialDelete(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <material-c-s-select ref="selectMaterial" @select="getDetails"/>
      <div
          style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
        订单附件
      </div>
      <div
          style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
        <el-upload
            :action="actionUrl"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handlerError"
            :file-list="files"
            :show-file-list="false">
          <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
        </el-upload>
      </div>
      <el-table
          ref="payData1"
          :data="replacementBillVo.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.fileName"
                class="tabInput"
                style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
            <el-button type="danger" @click="oneDelete(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
    <delivery-type-select ref="deliverySelect" @select="deliverySelect"/>
    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        @closeClick="photoVisible = false"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import constants from "@/util/constants";
  import auth from "@/util/loginUtil";
  import DeliveryTypeSelect from "@/views/afterSalesManagement/Replacement/DeliveryTypeSelect";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";
  import BigImg from "@/components/BigImg";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";

  export default {
    name: "ReplacementApprovePreview",
    components: {CustomerSelect, BigImg, MaterialCSSelect, DeliveryTypeSelect, HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constant,
        constants,
        uploadLoading: false,
        addCsSpecialLoading: false,
        saveLoading: false,
        photoVisible: false,
        files: [],
        imgUrls: [],
        fileList: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        nodeId: "",
        bigImgUrl: "",
        activeName: "first",
        replacementBillVo: {
          pkid: "",
          billNo: "",
          specialApplicationResult: "",
          customerBillNo: "",
          createTime: "",
          creatorName: loginUtil.getUserName(),
          faultSerialNO: "",
          customerId: "",
          customerName: "",
          factoryNo: "",
          salesOrderNo: "", //出厂编号
          consigneeMobile: "",
          contact: "",
          mobile: "",
          stage: "",
          consignee: "",
          deliveryType: "",
          deliveryAddress: "",
          note: "",
          attachments: [],
          details: [],
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getNodeValue();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `replacementBills/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.replacementBillVo = resp;
            this.replacementBillVo.attachments.forEach(row => {
              if (row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              } else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            console.log(this.imgUrls);
          });
      },
      getDetails1() {
        this.replacementBillVo.details.push({
          pkid: 0,
          masterId: 0,
          materialId: -1,
          materialDesc: "",
          materialNo: "",
          quantity: "",
          deliveryPerson: "",
          deliveryType: "",
          deliveryAccount: "",
          unit: "",
        });
      },
      deliverySelect(row) {
        console.log(row);
        console.log(this.replacementBillVo.details);
        this.replacementBillVo.details[row.groupIndex].deliveryType = row.deliveryTypeName;
        this.replacementBillVo.details[row.groupIndex].deliveryPerson = row.userName;
        this.replacementBillVo.details[row.groupIndex].deliveryAccount = row.account;
        this.replacementBillVo.details[row.groupIndex].setTime = row.setTime;
      },

      //附件表页面删除
      oneDelete(row, index) {
        this.replacementBillVo.attachments.splice(index, 1);
      },
      materialDelete(index, row) {
        console.log(row);
        this.replacementBillVo.details.splice(index, 1);
      },
      getDetails(row, index) {
        this.replacementBillVo.details[index].materialId = row.id;
        this.replacementBillVo.details[index].materialDesc = row.name;
        this.replacementBillVo.details[index].materialNo = row.no;
        this.$http
          .get("basic", `sAPSaleOrderDetails/materialNo/${row.no}`)
          .then(resp => {
            this.replacementBillVo.details[index].price = resp.price;
            this.calculateAllAmount();
          });
      },
      //计算总金额
      calculateAllAmount() {
        this.replacementBillVo.allAmount = 0;
        this.replacementBillVo.details.forEach(row => {
          this.replacementBillVo.allAmount += row.price;
        });
      },
      downLoad(row) {
        console.log(row);
        if (row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          let a = document.createElement("a");
          a.href = "http://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
      showBigImage(row) {
        this.photoVisible = true;
        if (row.filePath.includes("common")) {
          this.bigImgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        } else {
          this.bigImgUrl = "http://emes.stepelectric.com" + row.filePath;
        }

      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      handleSuccess(response, file, fileList) {
        console.log(file);
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.replacementBillVo.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      toDoApprove() {
        console.log(this.params);
        if (this.params.actionType === 0) {
          if (this.nodeId.includes("csApprove")) {
            const hasInvalidDetail = this.replacementBillVo.details.some(item => {
              return !item.deliveryType || !item.deliveryPerson;
            });

            if (hasInvalidDetail) {
              return this.$message.error("发运类型和发运人不能为空！！！");
            }
            if (this.params.applicationVarVOS[0].varValue === "true") {
              if (this.replacementBillVo.salesOrderNo === "" || this.replacementBillVo.salesOrderNo === null) {
                return this.$message.error("需要质量调查，出场编号不能为空！！！");
              }
              let item = {
                approveNote: this.params.approveNote,
                csId: this.replacementBillVo.pkid,
              };
              this.$http
                .put("basic", "improvedSurveys/addImprovedSurvey", item)
                .then(() => {
                });
            }
            // this.params.applicationVarVOS[0].varValue = this.improvedSurvey.isImproved + "";
            // this.params.applicationVarVOS[1].varValue = this.improvedSurvey.improvedHandelId + "";
            // this.params.applicationVarVOS[2].varValue = this.improvedSurvey.dutyType + "";
            // this.toSave();
          } else if (this.nodeId === "csReapprove") {
            // 复审发货通知
            this.$http
              .put("basic", "replacementBills/deliveryRelease", this.replacementBillVo)
              .then(() => {
              });
          }
          this.toSave();
        }
        if (this.params.actionType === 2) {
          this.updateStatus();
        }
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          approveVar: approveVar,
          billParam: "",
        };
        this.doApprove(params);
      },
      selectCustomer(row) {
        console.log(row);
        this.replacementBillVo.customerName = row.customerName;
        this.replacementBillVo.customerId = row.customerID;
      },
      toSave() {
        this.saveLoading = true;
        this.$http
          .put("basic", "replacementBills", this.replacementBillVo)
          .then(() => {
            this.$message.success("保存成功");
            this.saveLoading = false;
          }).catch(() => {
            this.saveLoading = false;
          });
      },
      addCsSpecialApplication() {
        this.addCsSpecialLoading = true;
        this.$http.post("basic", `csSpecialApplications/addCsSpecialApplication/${this.billId}`)
          .then(() => {
            this.$message.success("创建成功");
            this.addCsSpecialLoading = false;
          }).catch(() => {
            this.addCsSpecialLoading = false;
          });
      },
      doApprove(params) {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/ReplacementApprove",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.replacementBillVo.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      // 物料选择对话框
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      updateStatus() {
        this.$http
          .get("basic", `replacementBills/back/${this.replacementBillVo.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            console.log(this.nodeId);
            if (this.nodeId === "cqeApprove") {
              this.activeName = "second";
            } else if (this.nodeId === "improvedMeasure" || this.nodeId === "improvedMeasure_fs" || this.nodeId === "cqeApprove_fs") {
              this.activeName = "third";
            } else if (this.nodeId === "improvedMeasureSubmit") {
              this.activeName = "fourth";
            } else if (this.nodeId === "improvedMeasureVerify") {
              this.activeName = "five";
            } else if (this.nodeId.includes("orderVerify")) {
              this.activeName = "six";
            } else {
              this.activeName = "first";
            }
          });
      },
    },
  };
</script>
<style lang="scss">
table.ProjectOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
